import {
  store
} from "@/store/index.js";

export const routejs = {
  check(dNum) {
    let locat = window.location.pathname;
    if (locat.startsWith("/feeds") && dNum === 1) {
      store.commit("showGlobalFeed", true);
    } else if (locat.startsWith("/tasks/") && dNum === 2) {
      let taskID = parseInt(locat.replace('/tasks/', ''));
      if (!isNaN(taskID) && Number.isInteger(taskID)) {
        store.commit("showGlobalFeed", false);
        store.commit('taskFromLink', true);
        store.commit("setTabIndex", 1);
        store.commit("setSidebarItemSelection", {
          tabIndex: 1,
          id: taskID
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/router/routemanage.js